<template>
	<header class="masthead">
		<div class="container px-4 px-lg-5 h-100">
			<div class="
          row
          gx-4 gx-lg-5
          h-100
          align-items-center
          justify-content-center
          text-center
        ">
				<div class="col-lg-8 align-self-end">
					<h1 class="text-white font-weight-bold">YiWen的个性网站</h1>
					<hr class="divider" />
				</div>
				<div class="col-lg-8 align-self-baseline">
					<p class="text-white-75 mb-5">
						我想在这里放满我的作品，或者其他什么的︿(￣︶￣)︿
					</p>
					<router-link class="btn btn-primary btn-xl" to="/Applet">要看看我的作品吗？</router-link>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
	export default {
		name: "HomePage",
		methods: {
			huan() {
				this.$emit("up", "Applet");
			},
		},
	};
</script>

<style>
	header.masthead {
		min-height: 100vh;
		padding-top: 10rem;
		padding-bottom: calc(10rem - 4.5rem);
		background: linear-gradient(to bottom, rgba(92, 77, 66, 0.6) 0%, rgba(92, 77, 66, 0.6) 100%), url("../assets/Background/bg-masthead.png");
		background-position: center;
		background-repeat: no-repeat;
		background-attachment: scroll;
		background-size: cover;
	}
</style>
